import { render, staticRenderFns } from "./process_rate.vue?vue&type=template&id=3615df76&scoped=true"
import script from "./process_rate.vue?vue&type=script&lang=js"
export * from "./process_rate.vue?vue&type=script&lang=js"
import style0 from "./process_rate.vue?vue&type=style&index=0&id=3615df76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615df76",
  null
  
)

export default component.exports